// extracted by mini-css-extract-plugin
module.exports = {"textareaWrapper":"TextArea_textareaWrapper__1uSwz","captionAsCount":"TextArea_captionAsCount__29l3w"};